/**
 * Sonner toast provider — Slate & Field Green theme.
 *
 * Drop <Toaster /> once in App.tsx to make toast() available globally.
 * Usage: import { toast } from "sonner"; toast.success("Imported 16 blocks");
 */
import { Toaster as SonnerToaster } from "sonner";

export function Toaster() {
  return (
    <SonnerToaster
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast:
            "group bg-surface border border-line shadow-menu rounded-md text-sm text-ink font-sans",
          description: "text-ink-muted text-xs",
          actionButton:
            "bg-accent text-accent-text text-xs font-semibold rounded px-2 py-1 hover:bg-accent-hover transition",
          cancelButton:
            "bg-surface-sunken text-ink-secondary text-xs rounded px-2 py-1 hover:bg-surface-raised transition",
          error:
            "!border-status-critical/30 !bg-status-critical/5",
          success:
            "!border-accent/40 !bg-accent-subtle !text-accent-deep",
          warning:
            "!border-status-warning/30 !bg-status-warning/5",
          info:
            "!border-accent/30 !bg-accent-subtle !text-accent-text",
        },
      }}
    />
  );
}
